export default {
  theme: () => import(/* webpackChunkName: "pionir-themeWrap" */'./ThemeImporter'),
};
